<p>bot-auth works!</p>
<h1>{{token}}</h1>
<pre>
    {{user | json}}
</pre>

<h2 *ngIf="error" style="color: red;">
    {{message}}
</h2>